import api from './client.js'

export const gameServersAPI = {
  getServers: () => api.get('/game-servers'),
  getServer: (serverId) => api.get(`/game-servers/${serverId}`),
  getAllServers: () => api.get('/game-servers/admin/all'),
  getSupportedGames: () => api.get('/game-servers/supported-games'),
  createServer: (serverData) => api.post('/game-servers', serverData),
  updateServer: (serverId, serverData) => api.put(`/game-servers/${serverId}`, serverData),
  deleteServer: (serverId) => api.delete(`/game-servers/${serverId}`),
  updatePlayerCount: (serverId, playerCount) =>
    api.patch(`/game-servers/${serverId}/players`, { current_players: playerCount }),
  importFromPterodactyl: () => api.post('/game-servers/import-pterodactyl'),
}

export const pterodactylAPI = {
  getServers: (all = false) => api.get(`/pterodactyl/servers${all ? '?all=1' : ''}`),
  getServersBasic: () => api.get('/pterodactyl/servers/basic'),
  sendCommand: (identifier, command) =>
    api.post(`/pterodactyl/servers/${identifier}/command`, { command }),
  sendPower: (identifier, signal) =>
    api.post(`/pterodactyl/servers/${identifier}/power`, { signal }),
  setVisibility: (identifier, is_hidden) =>
    api.patch(`/pterodactyl/servers/${identifier}/visibility`, { is_hidden }),
  setDisplayName: (identifier, display_name) =>
    api.put(`/pterodactyl/servers/${identifier}/display-name`, { display_name }),
  getMinecraftItems: (identifier) => api.get(`/pterodactyl/servers/${identifier}/mc-items`, { timeout: 30000 }),
  getStorageUsage: () => api.get('/pterodactyl/storage'),
}

export const miniGamesAPI = {
  getGames: () => api.get('/mini-games/games'),
  getLeaderboard: (gameName, limit = 10) => api.get(`/mini-games/${gameName}/leaderboard?limit=${limit}`),
  getPersonalBest: (gameName) => api.get(`/mini-games/${gameName}/personal-best`),
  submitScore: (gameName, score) => api.post(`/mini-games/${gameName}/scores`, { score }),
  getMyScores: (limit = 20) => api.get(`/mini-games/my-scores?limit=${limit}`),
}

export const teamSpeakAPI = {
  getStatus: () => api.get('/teamspeak/status'),
  getClients: () => api.get('/teamspeak/clients'),
  powerAction: (action) => api.post('/teamspeak/power', { action }),
}
